import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";

interface AlertConfirmationProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  setAlertModelShow?: any;
  // submitHandler?: () => void;
}

const AlertConfirmation: React.FC<AlertConfirmationProps> = ({
  open,
  title,
  onHide = () => {},
  setAlertModelShow
  // submitHandler = () => {}
}) => {
  const classes = useStyles();

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition

 
  const closeModel =() =>{
    setAlertModelShow(false);
     onHide();
  }
  return (
    <Popup
      open={open}
      title={title || ""}
      onHide={onHide}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Quotation needs to be created before proceeding.
            </Alert>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertConfirmation;
